const projectFilterQueryKeys = [
  "q",
  "created_from",
  "created_to",
  "study_type_id",
  "study_type_label",
  "study_type_ids",
  "study_type_labels",
  "project_type_option_id",
  "project_type_label",
  "project_type_option_ids",
  "project_type_labels",
  "client_id",
  "client_label",
  "client_ids",
  "client_labels",
];

const arrayQueryKey = (key) => `${key}[]`;

const allQueryValues = (params, key) => [
  ...params.getAll(arrayQueryKey(key)),
  ...params.getAll(key),
];

const filterOptionsFromQuery = (params, valueKey, labelKey, legacyValueKey, legacyLabelKey) => {
  const values = allQueryValues(params, valueKey);
  const labels = allQueryValues(params, labelKey);
  const legacyValue = params.get(legacyValueKey);
  const legacyLabel = params.get(legacyLabelKey);
  const sourceValues = values.length ? values : legacyValue ? [legacyValue] : [];

  return sourceValues
    .map((value, index) => filterOptionFromQuery(value, labels[index] || legacyLabel || value))
    .filter(Boolean);
};

const filterOptionFromQuery = (value, label) => {
  const normalizedValue = value || "";
  const normalizedLabel = label || value || "";

  if (!normalizedValue && !normalizedLabel) return null;

  return {
    value: normalizedValue || normalizedLabel,
    label: normalizedLabel || normalizedValue,
    name: normalizedLabel || normalizedValue,
  };
};

export const projectFilterStateFromSearch = (search = "") => {
  const params = new URLSearchParams(search || "");

  return {
    search: params.get("q") || "",
    startDate: params.get("created_from") || "",
    endDate: params.get("created_to") || "",
    studyType: filterOptionsFromQuery(
      params,
      "study_type_ids",
      "study_type_labels",
      "study_type_id",
      "study_type_label"
    ),
    projectType: filterOptionsFromQuery(
      params,
      "project_type_option_ids",
      "project_type_labels",
      "project_type_option_id",
      "project_type_label"
    ),
    client: filterOptionsFromQuery(
      params,
      "client_ids",
      "client_labels",
      "client_id",
      "client_label"
    ),
  };
};

const appendOptionParams = (params, valueKey, labelKey, options) => {
  (Array.isArray(options) ? options : []).forEach((option) => {
    const value = option?.value ?? option?.id ?? "";
    const label = option?.label ?? option?.name ?? "";

    if (value !== "") params.append(arrayQueryKey(valueKey), String(value));
    if (label !== "") params.append(arrayQueryKey(labelKey), String(label));
  });
};

export const writeProjectFiltersToParams = (params, filters = {}, visibility = {}) => {
  projectFilterQueryKeys.forEach((key) => {
    params.delete(key);
    params.delete(arrayQueryKey(key));
  });

  if (visibility.canSearch !== false && String(filters.search || "").trim()) {
    params.set("q", String(filters.search).trim());
  }

  if (visibility.canViewCreatedDate !== false && filters.startDate) {
    params.set("created_from", filters.startDate);
  }

  if (visibility.canViewCreatedDate !== false && filters.endDate) {
    params.set("created_to", filters.endDate);
  }

  if (visibility.canViewStudyType !== false) {
    appendOptionParams(params, "study_type_ids", "study_type_labels", filters.studyType);
  }

  if (visibility.canViewProjectType !== false) {
    appendOptionParams(
      params,
      "project_type_option_ids",
      "project_type_labels",
      filters.projectType
    );
  }

  if (visibility.canViewClient !== false) {
    appendOptionParams(params, "client_ids", "client_labels", filters.client);
  }

  return params;
};

export const projectFilterQueryString = (filters = {}, visibility = {}) => {
  const params = writeProjectFiltersToParams(new URLSearchParams(), filters, visibility);

  return params.toString();
};

export const projectFilterSearchSuffix = (filters = {}, visibility = {}) => {
  const query = projectFilterQueryString(filters, visibility);

  return query ? `&${query}` : "";
};

export const projectFiltersMatchSearch = (search = "", filters = {}, visibility = {}) => {
  const currentParams = new URLSearchParams(search || "");
  const nextParams = new URLSearchParams(search || "");

  writeProjectFiltersToParams(nextParams, filters, visibility);

  return currentParams.toString() === nextParams.toString();
};
